import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './index.scss';

interface DownloadBarProps {
    className?: string;
    onClose: () => void;
    onClick: (type: string) => void;
}

function DownloadBar(props: DownloadBarProps) {
    const { onClick, onClose } = props;
    const [amount, setAmount] = useState('');

    useEffect(() => {
        axios.get('https://5thave-prod.bieyangapp.com/api/v1/appconfig')
            .then(res => {
                const { newcomerBenefits } = res.data.newcomerConfig;
                setAmount(newcomerBenefits ? newcomerBenefits.priceWithCurrencyText : '');
            })
    }, []);

    return (
        <div className='c-app-download'>
            <div onClick={onClose} className='close'></div>
            <img className='logo' src='https://baleen-cdn-g.bybieyang.com/static/images/logo.png' />
            <div className='content'>
                <div className='title'>别样海外购APP</div>
                <div className='sub-title'>新用户可限时领取<span className='yellow'>{amount}大礼包</span></div>
            </div>
            <div onClick={() => onClick('download')} className='button'>打开APP</div>
        </div>
    )
}

export default DownloadBar